import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import '../styles/safaris.css'
import Helmet from '../components/Helmet/Helmet';

import SafariImageBox from '../components/safarisImageBox/safariImageBox'
import Gc from '../components/Gc/Gc';

import MainImage from '../assets/images/277253851_1386129421849262_6655899923957163060_n.jpg'
import Pale_Blue_White_Nature_Snowy from '../assets/images/Pale-Blue-White-Nature-Snowy-Mountain-Photo-Book-Cover.webp-e1706119313766.webp'
import YALA from '../assets/images/YALA-copy.webp'
import wilpattu from '../assets/images/wilpattu.webp'
import horton from '../assets/images/horton.webp'
import sinharaja from '../assets/images/sinharaja.webp'
import snake from '../assets/images/5-qidmmqopxdbnqynau3s0iro13ospxqte2ijkqta70w.webp'

import IMG_4158 from '../assets/images/2023_02_25_09_58_IMG_4158.jpg'
import IMG_2611 from '../assets/images/IMG_2611.webp'
import WA0103 from '../assets/images/IMG-20240222-WA0103.jpg'
import WA0106 from '../assets/images/IMG-20240222-WA0106.jpg'
import WA0105 from '../assets/images/IMG-20240222-WA0105.jpg'
import WA0104 from '../assets/images/IMG-20240222-WA0104.jpg'

import comma from '../assets/images/comma.png'
import arrow from '../assets/icons/arrow-right-s-line.svg'

const items = [
  { xs: 2, imgSrc: IMG_4158 },
  { xs: 2, imgSrc: IMG_2611 },
  { xs: 2, imgSrc: WA0103 },
  { xs: 2, imgSrc: WA0106 },
  { xs: 2, imgSrc: WA0105 },
  { xs: 2, imgSrc: WA0104 },
];

const feedbacks = [
  {
    text: 
    "I recently went on a tour in Hortons plains with Ravisara and that was the first time I met him. He is simply a young man with a through knowledge and awesome tracking skills. He is a passionate wildlife photographer too. It was really easy to work with him as he was very friendly and tried to do his best to deliver an excellent service. I'm already planning another tour with Ravisara and strongly recommend him for anyone thinking of a wildlife photography tour in Sri Lanka.",
    author: "Dr. Goshaka Alugolla"
  },
  {
    text:
    "Ravisara Jayamanna to the humble and a rare soul I met this journey. you're so talented, so precise in what you do and you are gifted. what you do is beyond amazing and it has been a treat to do this whole journey with you. i am a big fan of you and i wish we get to do alot more safaris together in the future. your work shows how humble you are and i hope you grow everyday as a photographer. you have a very bright future ahead of you so don't ever change who you are. thank you for being so kind and helping us get the best shots possible. this trip is so memorable because you worked so hard to find us the possibilities to get the best photos. so thank you once again...",
    author: "Aishath Jazla"
  },
  {
    text: 
    "I had traveled to srilanka in Feb 2023 with Ravisara to visit Yala National Park. It was a great experience, He has amazing knowledge about the park and species. He knew exactly what as a wildlife photographer my requirements were and made sure those were met. He is a great wildlife photographer. I am working on my next trip with him to Srilanka.",
    author: "Hymkar Valluri (Winner of Natgeo 2017 TPOT)"
  },
  {
    text: 
    "We booked a 2 day full safari with Ravi and Asinka. Ravis knowledge of the terrain and the species along with the spotting skills of Asinka were immensely helpful on our guided safari. We are thankful for his services.",
    author: "Mr. Nikhil Bhambure"
  },
  {
    text: 
    "I suggest you join the wildlife photographer tour at Wilpattu National Park in Sri Lanka. It’s organized by Ravisara. Whether you’re new to photography or very experienced, this tour is a great chance to see Sri Lanka’s amazing animals and get better at taking pictures. A professional photographer will help you learn.",
    author: "Mr. Shanaka Don"
  },
  {
    text: 
    "Our safari with Ravisara at Wilpattu National Park was so amazing! Ravisara's expertise and passion for wildlife made the experience truly amazing. We were on the lookout for leopards, and thanks to Ravisara's keen eyes and in-depth knowledge of the park, we were fortunate enough to spot almost 20 of these magnificent creatures. It was a breathtaking sightings and nature. Overall, our journey with Ravisara at Wilpattu National Park was an absolute delight. If you're looking for an experienced and enthusiastic guide who can enhance your safari experience, Ravisara is the perfect choice. A five-star adventure filled with excitement and the incredible sight of leopards in their natural habitat!",
    author: "Mr. Muhammed Zidan"
  }
];


const Safaris = () => {

  const [currentFeedback, setCurrentFeedback] = useState(0);
  const [animationDirection, setAnimationDirection] = useState('');

  useEffect(() => {
    const resetAnimation = setTimeout(() => setAnimationDirection(''), 500);
    return () => clearTimeout(resetAnimation);
  }, [currentFeedback]);

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimationDirection('next');
      setCurrentFeedback((prevFeedback) => (prevFeedback + 1) % feedbacks.length);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const handleNextFeedback = () => {
    setAnimationDirection('next');
    setCurrentFeedback((prevFeedback) => (prevFeedback + 1) % feedbacks.length);
  };

  const handlePrevFeedback = () => {
    setAnimationDirection('prev');
    setCurrentFeedback((prevFeedback) => (prevFeedback - 1 + feedbacks.length) % feedbacks.length);
  };

  const handleDotClick = (index) => {
    setAnimationDirection(index > currentFeedback ? 'next' : 'prev');
    setCurrentFeedback(index);
  };

  return <>
  <Helmet title={'safaris'}>
  <section className="safari__main">
    <div className="w-1">
        <h1 className='__h1' >Safaris</h1>
        <span className='dash'></span>
        <img className='safari__main-image' src={MainImage} alt="" />
    </div>
  </section>
  <section className="wildlife__safari">
    <div className="w-1">
        <h1 className='e wildlife__safari-h1'>Wildlife Safaris</h1>
        <p className='e wildlife__safari-text'>I organize wildlife photography tours at a reasonable cost so that anyone can join me and learn. I have a 5 year of experience in the field and can provide you with best of opportunities and sceneries along with good photography tips and techniques.</p>
        <div className='wildlife__safari-cards fsb'>
        <SafariImageBox
            imgSrc={Pale_Blue_White_Nature_Snowy}
            text='Customized Wildlife Photography Tour'
            to='/customized-wildlife-photography-learning-tour'
         />
        <SafariImageBox
            imgSrc={YALA}
            text='Land of Leopards'
            to='/yala-national-park'
         />
        <SafariImageBox
            imgSrc={wilpattu}
            text='Land of Lakes'
            to='/wilpattu-national-park'
         />
        <SafariImageBox
            imgSrc={horton}
            text='Land of Montane Leopards'
            to='/horton-plains-national-park'
         />
        <SafariImageBox
            imgSrc={sinharaja}
            text='Land of Endemics'
            to='/sinharaja-bird-watching'
         />
        <SafariImageBox
            imgSrc={snake}
            text='Herping Tours'
            to='/herping-tours'
         />
        </div>
        <Link className="wildlife__plan-link" to='/contact'>Plan Your Wildlife Tour</Link>
    </div>
  </section>
  <section className="feedback__experience">
    <div className="w-1">
        <h1 className='e feedback__experience-title'>Guest Feedback & Experience</h1>
        <div className="feedback__carousel">
          <div className={`feedback__carousel-content ${animationDirection}`}>
            <img className='q' src={comma} alt="" />
            <p className='feedback__carousel-content-p'>{`"${feedbacks[currentFeedback].text}"`}</p>
            <span className='dash'></span>
            <h2 className='feedback__carousel-content-h'>{feedbacks[currentFeedback].author}</h2>
          </div>
          <div className="feedback__carousel-navigation fsb">
            <div className='feedback__carousel-navigation-dots'>
              {feedbacks.map((_, index) => (
                <span
                  key={index}
                  className={`feedback__carousel-navigation-dot ${currentFeedback === index ? 'active' : ''}`}
                  onClick={() => handleDotClick(index)}
                ></span>
              ))}
            </div>
            <div className='feedback__carousel-navigation-arrow'>
              <img className='feedback__carousel-navigation-arrow-left' src={arrow} alt="" onClick={handlePrevFeedback} />
              <img className='feedback__carousel-navigation-arrow-right' src={arrow} alt="" onClick={handleNextFeedback} />
            </div>
          </div>
        </div>
    </div>
  </section>
  <div className="safari_gallery-main">
    <div className='w-1 safari_gallery'>
      <Gc style={{height:'35vh'}} items={items} />
    </div>
  </div>
  </Helmet>
  </>
}

export default Safaris